export const AUTH_KEYS = {
	PAGE_USER_LIST: 'page_user_list',
	PAGE_USER_DETAIL: 'page_user_detail',
	PAGE_ORDER_LIST: 'page_order_list',
	PAGE_ORDER_CATEGORY: 'page_order_category',
	PAGE_ORDER_DETAIL_1: 'page_order_detail_1',
	PAGE_ORDER_DETAIL_2: 'page_order_detail_2',
};
